// Current app version - increment this when breaking changes require re-auth
export const APP_VERSION = '1.0.108';

// Version where breaking auth changes were introduced
export const MINIMUM_SUPPORTED_VERSION = '1.0.0';

// Get the stored version from localStorage
export function getStoredVersion(): string | null {
  return localStorage.getItem('app_version');
}

// Store the current version
export function storeCurrentVersion(): void {
  localStorage.setItem('app_version', APP_VERSION);
}

// Check if the stored version meets minimum requirements
export function isVersionSupported(): boolean {
  const storedVersion = getStoredVersion();
  
  if (!storedVersion) {
    return false;
  }

  // Compare versions using semver-like comparison
  const stored = storedVersion.split('.').map(Number);
  const minimum = MINIMUM_SUPPORTED_VERSION.split('.').map(Number);
  
  for (let i = 0; i < 3; i++) {
    if (stored[i] > minimum[i]) return true;
    if (stored[i] < minimum[i]) return false;
  }
  
  return true;
}

// Force update by clearing stored version
export function clearStoredVersion(): void {
  localStorage.removeItem('app_version');
}